import React from 'react'
import { WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from '@constants/contact'
import { LuMessageCircle, LuPhone, LuMail, LuExternalLink } from 'react-icons/lu'
import './ContactSection.css'

const contacts = [
  {
    icon: LuMessageCircle,
    label: 'WhatsApp',
    value: WHATSAPP_DISPLAY,
    href: `https://wa.me/${WHATSAPP_NUMBER}`,
    color: '#28a745',
    bgColor: 'rgb(240, 253, 244)',
    borderColor: 'rgba(40, 167, 69, 0.35)',
    borderRadius: '50%',
  },
  {
    icon: LuPhone,
    label: 'Telefone',
    value: '(11) 3171-1196',
    href: 'tel:+551131711196',
    color: '#FA5A84',
    bgColor: '#fcf0f6',
    borderColor: 'rgba(250, 90, 132, 0.3)',
    borderRadius: '50%',
  },
  {
    icon: LuMail,
    label: 'E-mail',
    value: 'reservas@pro-seed.com.br',
    href: 'mailto:reservas@pro-seed.com.br',
    color: '#3B82F6',
    bgColor: '#EFF6FF',
    borderColor: 'rgba(59, 130, 246, 0.3)',
    borderRadius: '50%',
  }
]

const ContactSection: React.FC<any> = () => {
  return (
    <section>
      <div className="mb-4">
        <span className="contact-kicker d-block font-weight-bold text-uppercase mb-1" style={{ color: '#FA5A84' }}>Acolhimento Individualizado</span>
        <h2 className="contact-title font-weight-bold text-dark mb-0">Conte com o apoio da nossa equipe especializada</h2>
      </div>

      <div className="row">
        {contacts.map(({ icon: Icon, label, value, href, color, bgColor, borderColor, borderRadius }) => (
          <div key={label} className="col-12 col-md-4 mb-3">
            <a href={href} target="_blank" rel="noreferrer" className="contact-card p-0 card h-100 border text-decoration-none text-reset" style={{ '--hover-border': borderColor, borderRadius: 16, boxShadow: '0 1px 6px rgba(0,0,0,0.05)' } as React.CSSProperties}>
              <div className="card-body d-flex align-items-center px-4 py-3" style={{ borderRadius: 16 }}>
                <div
                  className="d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
                  style={{ width: 48, height: 48, backgroundColor: bgColor, borderRadius }}
                >
                  <Icon size={20} style={{ color }} />
                </div>

                <div className="min-w-0 flex-grow-1">
                  <p className="contact-label text-muted mb-1">{label}</p>
                  <p className="contact-value mb-0 font-weight-bold text-truncate">{value}</p>
                </div>

                <LuExternalLink className="contact-external-icon ml-3 flex-shrink-0" size={16} style={{ color: '#9CA3AF' }} />
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ContactSection
